import axios from 'axios';
import {useMutation} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

import {onLogoutResponse} from './helper';

import {authAtom, cartAtom} from 'store';
import {useSetRecoilState} from 'recoil';

const logout = async () => axios.post(Routes.LOGOUT);

export const useLogout = () => {
  const setAuth = useSetRecoilState(authAtom);
  const setCart = useSetRecoilState(cartAtom);

  return useMutation({
    mutationKey: [Keys.LOGOUT_MUT],
    mutationFn: logout,
    onSuccess: () => onLogoutResponse({setAuth, setCart}),
  });
};
